import { render, staticRenderFns } from "./SensitiveContentSetupAge.vue?vue&type=template&id=a31ef47a&"
import script from "./SensitiveContentSetupAge.vue?vue&type=script&lang=ts&"
export * from "./SensitiveContentSetupAge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports